module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    attrs: {
      "data-animation": "pop"
    }
  }, [_c('em', {
    staticClass: "sa-icon sa-error fa fa-warning"
  }), _vm._v(" "), _c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("There is a problem")]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n        Commercial addresses are not allowed as an investor's residential\n        addresses.\n      ")]), _vm._v(" "), _c('fieldset', {
    staticClass: "checkbox c-checkbox override-row"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allowed),
      expression: "allowed"
    }],
    attrs: {
      "type": "checkbox",
      "name": "allowCommercialAddress"
    },
    domProps: {
      "checked": Array.isArray(_vm.allowed) ? _vm._i(_vm.allowed, null) > -1 : (_vm.allowed)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.allowed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allowed = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.allowed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allowed = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          Allow commercial address as residential\n        ")])]), _vm._v(" "), (_vm.allowed) ? _c('fieldset', {
    staticClass: "form-group override-row"
  }, [_c('label', {
    attrs: {
      "for": "commercialOverrideComment"
    }
  }, [_vm._v("\n          Override verified by\n          "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n            (who approved this and how it was verified, e.g. Google Maps)\n          ")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "commercialOverrideComment",
      "rows": "2",
      "placeholder": "e.g. Verified via Google Maps by Jane Admin"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg btn-accept",
    attrs: {
      "disabled": !_vm.canSave
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n              Save with override\n            ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69a61822","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CommercialAddressOverride.vue
// module id = 2165
// module chunks = 1